<template lang="pug">
    section.section.article-wrapper
        div.container.has-text-centered
            img.brand-logo(:src="'https://bo.herdadesaomiguel.com/assets/news/' + article.image + '_big.jpg'")
            div.columns.is-centered
                div.column.is-10
                    div.article-content.has-background-white
                        h3.is-size-11.is-uppercase.has-letter-spacing-200 {{ article.tag }} | {{ article.date }}
                        h1.is-size-25.has-text-weight-semibold {{ article.title }}
                        h2 {{ article.subtitle }}
                        div.is-separator
                        div.columns.is-centered
                            div.column.is-6.is-paddingless
                                p.has-text-justified {{ article.text }}

        //- div.previews
        //-     div.container.has-text-centered
        //-         span.has-letter-spacing-200 .....
        //-         h1.is-size-7.is-uppercase.has-letter-spacing-200 Outros artigos
        //-         div.columns.is-multiline
        //-             div.column.is-3(v-for="i in news")
        //-                 article-preview(:article="i")
</template>

<script>
import ArticlePreview from '@/components/news-article-preview'
export default {
    name: 'news-article',
    components: { ArticlePreview },
    data () {
        return {
            article: Object,
            news: Array
        }
    },
    mounted () {
        this.news = this.$t('page_10.articles')
        this.article = this.news.find(i => i.url.replace('/', '') === this.$route.params.id)
    }
}
</script>

<style lang="stylus" scoped>

.article
    &-wrapper
        padding-top 93px

    &-content
        margin-top -50px
        padding 125px 0

        > *
            margin-bottom 25px

.is-separator
    margin 25px 0 50px 0

</style>
